<div class="full-sheet app-consent-sheet" [@sheetUp]="animationState">
  <div *ngIf="isLoading" class="full-sheet__loader">
    <i class="icon loader--spinner"></i>
  </div>
  <ng-container *ngIf="!isLoading">
    <div class="full-sheet__logo">
      <div class="logo--air-miles"></div>
    </div>
    <div class="app-consent-sheet__text">
      <div>
        <h1>{{ appConsentData?.title }}</h1>
        <div [internalInnerHtml]="appConsentData?.body" [userEventSource]="userEventSource"></div>
      </div>
      <ion-item>
        <ion-toggle
          [(ngModel)]="accept"
          (click)="onToggleChange()"
          color="primary"
          [attr.aria-label]="label"
          labelPlacement="start"
          justify="start"
          mode="md"
        >
          {{ label }}
        </ion-toggle>
      </ion-item>
      <a (click)="close()" class="button button--primary button--full-width">{{ "general.label.close" | translate }}</a>
    </div>
  </ng-container>
</div>
